import { laisPath } from '../laisRouteHelpers';

const VisitasIndex = () => import('../visitas/pages/VisitasIndex.vue');

export const GET_KEYS_PATH = laisPath('minhas-chaves/imovel/:houseId/retirada');

export default {
  path: GET_KEYS_PATH,
  component: VisitasIndex,
  meta: {
    referenceAuthenticated: true,
  },
};
